// Application Configuration
const appConfig = {
  // University Information
  university: {
    name: 'Mewar University',
    shortCode: 'MUE',
    publicKey: 'D7680C167880B40F'
  },
  
  // Payment Configuration
  payment: {
    currency: 'INR',
    defaultDescription: 'Application Fee Payment'
  },
  
  // API Configuration
  api: {
    timeout: 15000, // 15 seconds
    retryAttempts: 3
  },
  
  // Form Configuration
  form: {
    maxFileSize: 5 * 1024 * 1024, // 5MB
    allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg', 'application/pdf']
  },
  
  // Cloudflare R2 Configuration
  cloudflare: {
   
  }
};

export default appConfig;
